import { Component } from '@angular/core';
import { ButtonModule } from 'primeng/button';
import { SystemPageComponent } from '../system-page/system-page.component';

@Component({
  selector: 'app-access-denied',
  imports: [ButtonModule, SystemPageComponent],
  templateUrl: './access-denied.component.html',
  styleUrl: './access-denied.component.css',
})
export class AccessDeniedComponent {}
